// Enums for Color and Size
const ProductCategory = Object.freeze({
  Furniture: 'Furniture',
  Electronics: 'Electronics',
  Clothing: 'Clothing',
  Accessories: 'Accessories',
  Books: 'Books',
  Beauty: 'Beauty',
  Sports: 'Sports',
  Toys: 'Toys',
  Automotive: 'Automotive',
  Groceries: 'Groceries',

  });
  
  const ProductColor = Object.freeze({
    Black: 'Black',
    Gray: 'Gray',
    Red: 'Red',
    Blue: 'Blue',
  });
  
  const ProductSize = Object.freeze({
    Standard: 'Standard',
    Large: 'Large',
    Small: 'Small',
  });
  
  class Product {
    constructor({
      productId,
      title,
      description,
      category,
      whyChooseUs,
      weight,
      dimensions,
      price,
      hasDiscount,
      discountPrice,
      hasSize,
      hasColor,
      variants = [],
      availableStock,
      images = [],
      createdAt,
      totalPeopleReview = 1,
      totalRating = 5,
    }) {
      this.productId = productId;
      this.title = title;
      this.description = description;
      this.category = category;
      this.whyChooseUs = whyChooseUs;
      this.weight = weight;
      this.dimensions = dimensions;
      this.price = price;
      this.hasDiscount = hasDiscount;
      this.discountPrice = discountPrice;
      this.hasSize = hasSize;
      this.hasColor = hasColor;
      this.variants = variants;
      this.availableStock = availableStock;
      this.images = images;
      this.createdAt = createdAt;
      this.totalPeopleReview = totalPeopleReview;
      this.totalRating = totalRating;
    }
  
    // Factory method to create Product from an object
    static fromMap(map) {
      return new Product({
        productId: map.productId,
        title: map.title,
        description: map.description,
        category: map.category ? ProductCategory[map.category] : undefined,
        whyChooseUs: map.whyChooseUs,
        weight: map.weight,
        dimensions: map.dimensions,
        price: map.price,
        hasDiscount: map.hasDiscount,
        discountPrice: map.discountPrice,
        hasSize: map.hasSize,
        hasColor: map.hasColor,
        variants: map.variants.map((variant) => ({
          size: variant.size ? ProductSize[variant.size] : undefined,
          color: variant.color ? ProductColor[variant.color] : undefined,
          stock: variant.stock,
        })),
        availableStock: map.availableStock,
        images: map.images,
        createdAt: map.createdAt,
        totalPeopleReview: map.totalPeopleReview || 1, // Set default if undefined
        totalRating: map.totalRating || 5,
      });
    }
  
    // Convert Product to an object (for saving to database)
    toMap() {
      return {
        productId: this.productId,
        title: this.title,
        description: this.description,
        category: this.category,
        whyChooseUs: this.whyChooseUs,
        weight: this.weight,
        dimensions: this.dimensions,
        price: this.price,
        hasDiscount: this.hasDiscount,
        discountPrice: this.discountPrice,
        hasSize: this.hasSize,
        hasColor: this.hasColor,
        variants: this.variants.map((variant) => ({
          size: variant.size,
          color: variant.color,
          stock: variant.stock,
        })),
        availableStock: this.availableStock,
        images: this.images,
        createdAt: this.createdAt,
        totalPeopleReview: this.totalPeopleReview,
        totalRating: this.totalRating,
      };
    }
  
    // Method to update product details
    toUpdateMap() {
      const map = {};
      if (this.title) map.title = this.title;
      if (this.description) map.description = this.description;
      if (this.category) map.category = this.category;
      if (this.whyChooseUs) map.whyChooseUs = this.whyChooseUs;
      if (this.weight) map.weight = this.weight;
      if (this.dimensions) map.dimensions = this.dimensions;
      if (this.price) map.price = this.price;
      if (this.hasDiscount) map.hasDiscount = this.hasDiscount;
      if (this.discountPrice) map.discountPrice = this.discountPrice;
      if (this.hasSize) map.hasSize = this.hasSize;
      if (this.hasColor) map.hasColor = this.hasColor;
      if (this.variants) map.variants = this.variants;
      if (this.availableStock) map.availableStock = this.availableStock;
      if (this.images) map.images = this.images;
      if (this.createdAt) map.createdAt = this.createdAt;
      if (this.totalPeopleReview) map.totalPeopleReview = this.totalPeopleReview;
      if (this.totalRating) map.totalRating = this.totalRating;
      return map;
    }
  }
  
  export { Product, ProductCategory, ProductColor, ProductSize };
  